module.exports = offices;